export default __webpack_public_path__ + "static/media/online-ticketing.c7035fbc.png";